import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-project',
  templateUrl: './add-project.component.html',
  styleUrls: ['./add-project.component.css']
})
export class AddProjectComponent implements OnInit {

  formGroup: UntypedFormGroup;
  userId:any;
  isEditable:boolean=false;
  constructor(private formBuilder: UntypedFormBuilder, private auth: AuthService, private activatedRoute: ActivatedRoute, private router:Router, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
          _id:[''],
          clientName: ['', Validators.required],
          domain: ['', Validators.required],
          industry: ['', Validators.required],
          userName: ['', Validators.required],
          captainEmail: ['', [
              Validators.required,
              Validators.pattern(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
          ]],
          email: ['', [
              Validators.required,
              Validators.pattern(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
          ]],
          phone: ['', Validators.required],
          contactPersonName: ['', Validators.required],
          isDemoLive: ['', Validators.required],
          demoStartDate: [''],
          liveDate: [''],
          endDate: [''],
          sendWhatsapp: [false]
    });
    this.activatedRoute.params.subscribe(params => {
      this.userId = params['id'];
      if (this.userId) {
        this.getProjectById(this.userId);
      }
    });
  }
  getProjectById(id:any){
    this.auth.getProjectById(id).subscribe((res:any)=>{
      this.formGroup.patchValue(res);
      this.isEditable = true;
      if(res.demoStartDate)
        this.formGroup.controls['demoStartDate'].setValue(new Date(res.demoStartDate))
      if(res.liveDate)
        this.formGroup.controls['liveDate'].setValue(new Date(res.liveDate))
    },(err:any)=>{
      console.log(err);
    })
  }

  isLiveOrNot(){
    return (this.formGroup.controls['isDemoLive'].value == 'isLive')
  }
  onSubmit() {
    // console.log(this.formGroup.value);
    if(this.formGroup.controls['_id'].value != '' &&  this.formGroup.controls['_id'].value != null)
    {
      this.auth.editProject(this.formGroup.value, this.formGroup.controls['_id'].value).subscribe((res:any)=>{
        this.toastr.success(res.message)
        this.formGroup.reset()
        this.router.navigateByUrl('/projects');
      },(err:any)=>{
        console.log(err);
        this.toastr.error(err.message)
      })
    }
    else
    {
      this.auth.addProject(this.formGroup.value).subscribe((res:any)=>{
        this.toastr.success(res.message)
        this.formGroup.reset();
        this.router.navigateByUrl('/projects');
      },(err:any)=>{
        console.log(err);
        this.toastr.error(err.message)
      })
    }
  }

}
